import { FC } from "react"
import { RateFlowDetails } from "../../../../../../types"
import RateflowGeneral from "./sections/general"
import RateflowPricingEngine from "./sections/pricing-engine"
import RateflowLoMap from "./sections/lo-map"

interface Props {
  values: RateFlowDetails
  tab: string
  setFormField: (name: string, value: any) => void
}

const ManageRateflowFormContent: FC<Props> = ({
  values,
  tab,
  setFormField
}) => {
  return (
    <>
      {tab === "general" && (
        <RateflowGeneral values={values} setFormField={setFormField} />
      )}
      {tab === "pricing-engine" && (
        <RateflowPricingEngine values={values} setFormField={setFormField} />
      )}
      {tab === "lo-map" && (
        <RateflowLoMap values={values} setFormField={setFormField} />
      )}
    </>
  )
}

export default ManageRateflowFormContent
